import UI, { CheckboxProps } from "./UI";

const Checkbox = ({
  label,
  checked,
  onChange,
  isValid,
  validate,
  disabled,
  className,
}: CheckboxProps) => {
  return (
    <UI
      label={label}
      checked={checked}
      onChange={onChange}
      isValid={isValid}
      validate={validate}
      disabled={disabled}
      className={className}
    />
  );
};

export default Checkbox;
